import script from "./foot.vue?vue&type=script&setup=true&lang=ts"
export * from "./foot.vue?vue&type=script&setup=true&lang=ts"

import "./foot.vue?vue&type=style&index=0&id=450d1dc3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-450d1dc3"]])

export default __exports__